import React, { Component } from 'react';
import { FORM_TYPE_CREATE_SCHEMA_SPEC } from '../../constants/formTypes';

import Form from '../elements/forms/Form';
import FormPage from '../elements/forms/FormPage';
import Constants from '../../Constants';
//form stages
import CreateSchemaSpecPage from './form/CreateSchemaSpecPage';

import './form/CreateSchemaSpecForm.scss';
import isNil from 'lodash/isNil';
import trim from 'lodash/trim';
// import map from 'lodash/map';
// import uniq from 'lodash/uniq';
import has from 'lodash/has';
// import forEach from 'lodash/forEach';
// import isEmpty from 'lodash/isEmpty';

import { getCodeForReusableRecordTx } from '../../lib/TransformsUtils';
import JSONUtils from '../../lib/JSONUtils';
import { SUPPORT_KEY_SCHEMA_SPEC } from '../../constants/supportPageKeys';
import { isEmpty } from 'lodash';

class CreateSchemaSpecForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentHeight: 800,
      awaitingSpecGenerationResponse: false,
    };

    this._validateSpec = this._validateSpec.bind(this);
  }

  componentDidMount() {
    if (this.props.formData.shouldInitFormData === true) {
      this.props.updateFormData(FORM_TYPE_CREATE_SCHEMA_SPEC, {
        ...this.props.formData,
        shouldInitFormData: false,
      });
    }

    this.props.setContextualSupport(SUPPORT_KEY_SCHEMA_SPEC);
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_SCHEMA_SPEC);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      formData: { specUpdateDone },
    } = this.props;

    const { awaitingSpecGenerationResponse } = this.state;

    if (awaitingSpecGenerationResponse && specUpdateDone) {
      this._boundValidateSpec();
    }
  }

  _handleSubmit = () => {
    this.props.onFormSubmitted();
  };

  _handleDismiss = () => {
    this.props.onFormDismissed();
  };

  _getTxPayload = (processSamples = false, currentInputValue = null) => {
    const {
      formData: { input },
    } = this.props;

    // Use the passed currentInputValue if available, otherwise use Redux state
    const inputToUse = currentInputValue !== null ? currentInputValue : input;

    let txPayloadCode = getCodeForReusableRecordTx([]);

    let inputSamples = null;
    if (processSamples === true) {
      inputSamples = JSONUtils.parseJson(inputToUse, true);
    }

    return { txPayloadCode, inputSamples };
  };

  _validateSpec(data, onSuccess, onError) {
    const { formData } = this.props;
    const { awaitingSpecGenerationResponse } = this.state;

    if (!has(formData, 'name') || isNil(formData.name) || trim(formData.name) === '') {
      onError('Please set a name for this template');
      return;
    }

    if (isEmpty(data.outputSchema?.schema?.properties)) {
      onError('Please generate the schema for this template');
      return;
    }

    if (awaitingSpecGenerationResponse) {
      if (has(formData, 'specUpdateError') && formData.specUpdateError) {
        this.setState({
          awaitingSpecGenerationResponse: false,
        });

        setTimeout(() => {
          this.props.updateFormData(FORM_TYPE_CREATE_SCHEMA_SPEC, {
            specUpdateDone: false,
            specUpdateError: null,
          });
        }, 100);
        onError(formData.specUpdateError.message);
        return;
      }

      this.setState({
        awaitingSpecGenerationResponse: false,
      });
      onSuccess();
      return;
    }
    this._boundValidateSpec = this._validateSpec.bind(this, ...arguments);

    this.setState(
      {
        awaitingSpecGenerationResponse: true,
      },
      () => {
        // this._;
        //create a new transform, or update existing one
        const {
          isEditMode,
          formData: {
            name,
            description,
            outputSchema: { schema, data_samples },
          },
        } = this.props;
        // let txCode = null;
        // // try {
        // //   txCode = convertCodeToTransform(code, codeLanguage);
        // // } catch (e) {
        // //   console.log('error in code');
        // //   txCode = null;
        // // }
        //
        // // const { txPayloadCode } = this._getTxPayload(false);
        // if (txCode === null) {
        //   this.setState({
        //     awaitingSpecGenerationResponse: false
        //   });
        //   return;
        // }

        const schemaSpecObject = {
          name: name ? name : '',
          description: description ? description : '',
          schema,
          data_samples,
        };

        if (isEditMode === false) {
          this.props.createSchemaSpecFromForm(FORM_TYPE_CREATE_SCHEMA_SPEC, schemaSpecObject);
        } else {
          this.props.updateSchemaSpecFromForm(
            FORM_TYPE_CREATE_SCHEMA_SPEC,
            this.props.specBeingEdited.id,
            schemaSpecObject,
          );
        }
      },
    );
  }

  _handleSpecGenerationTriggerd = (currentInputValue = null) => {
    const { testSchemaSpec } = this.props;

    const { txPayloadCode, inputSamples } = this._getTxPayload(true, currentInputValue);
    testSchemaSpec(txPayloadCode, inputSamples);
  };

  render() {
    const { isEditMode, transformBeingEdited } = this.props;
    const { formData, ...otherProps } = this.props;

    const title = isEditMode ? 'Edit Schema Template' : 'Create Schema Template';
    const subtitle =
      isEditMode && transformBeingEdited
        ? `${transformBeingEdited.name}(ID: ${transformBeingEdited.id})`
        : '';

    const submitButtonText = isEditMode ? 'Save' : 'Create';

    return (
      <Form
        title={title}
        type={FORM_TYPE_CREATE_SCHEMA_SPEC}
        subtitle={subtitle}
        onSubmit={this._handleSubmit}
        onDismiss={this._handleDismiss}
        submitButtonText={submitButtonText}
        alwaysShowCancel={true}
        onFormContentResized={this._onFormContentResized}
      >
        <FormPage
          title=""
          contentHeight={Constants.SCHEMA_EDITOR_FORM_HEIGHT}
          validationMethod={this._validateSpec}
        >
          <CreateSchemaSpecPage
            id={0}
            containerHeight={this.state.contentHeight}
            formType={FORM_TYPE_CREATE_SCHEMA_SPEC}
            {...formData}
            {...otherProps}
            onGenerateTestSpec={this._handleSpecGenerationTriggerd}
          />
        </FormPage>
      </Form>
    );
  }

  _onFormContentResized = (contentHeight = 800) => {
    this.setState({
      contentHeight: contentHeight,
    });
  };
}

CreateSchemaSpecForm.defaultProps = {
  isEditMode: false,
  transformBeingEdited: null,
};

export default CreateSchemaSpecForm;
